import { render, staticRenderFns } from "./yapireader.vue?vue&type=template&id=5b587886&"
import script from "./yapireader.vue?vue&type=script&lang=js&"
export * from "./yapireader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports